import React from "react"
import { Link, navigate } from "gatsby"

import Layout from "../components/shared/Layout"
import SEO from "../components/shared/seo"

const IndexPage = () => {
  if (typeof window !== "undefined") {
    navigate("/a/login")
  }
  return !true ? (
    <Layout>
      <SEO title="Home" />
      <h1>Public Index</h1>
      <Link to="/a/login">Login</Link>
    </Layout>
  ) : null
}

export default IndexPage
